module.exports = __webpack_public_path__ + "static/media/whiteTriangle.0d9cd79d.svg";